import React from 'react';
import Swal from 'sweetalert2';

const Dialogs = () => {
    const showBasicAlert = () => {
        Swal.fire({
            title: "Here's a message!",
            confirmButtonText: 'OK'
        });
    };

    const showTitleAlert = () => {
        Swal.fire({
            title: "Here's a message!",
            text: "It's pretty, isn't it?",
            confirmButtonText: 'OK'
        });
    };

    const showSuccessAlert = () => {
        Swal.fire({
            title: "Here's a message!",
            text: "It's pretty, isn't it?",
            icon: 'success',
            confirmButtonText: 'OK'
        });
    };

    const showHtmlAlert = () => {
        Swal.fire({
            title: 'HTML <small>Title</small>!',
            html: 'A custom <span style="color: #CC0000">html</span> message.',
            icon: 'success',
            confirmButtonText: 'OK'
        });
    };

    return (
        <div className="container-fluid">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1>Sweet Alert Ui</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">BrandSek</a></li>
                                <li className="breadcrumb-item"><a href="/">Components</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Sweet Alert</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-md-6 col-sm-12 text-right hidden-xs">
                        <a href="/" className="mr-1 btn btn-sm btn-primary" title="">Create Campaign</a>
                        <a href="https://themeforest.net/item/BrandSek-bootstrap-4x-admin-dashboard-clean-modern-ui-kit/23091507" className="btn btn-sm btn-success" title="Themeforest"><i className="icon-basket"></i> Buy Now</a>
                    </div>
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-md-6 col-sm-12">
                    <div className="card">
                        <div className="body">
                            <p>A basic message</p>
                            <button onClick={showBasicAlert} className="btn btn-primary btn-round js-sweetalert" data-type="basic">Click Me</button>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12">
                    <div className="card">
                        <div className="body">
                            <p>A title with a text under</p>
                            <button onClick={showTitleAlert} className="btn btn-primary btn-round js-sweetalert" data-type="with-title">Click Me</button>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12">
                    <div className="card">
                        <div className="body">
                            <p>A success message!</p>
                            <button onClick={showSuccessAlert} className="btn btn-primary btn-round js-sweetalert" data-type="success">Click Me</button>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12">
                    <div className="card">
                        <div className="body">
                            <p>An HTML message</p>
                            <button onClick={showHtmlAlert} className="btn btn-primary btn-round js-sweetalert" data-type="html-message">Click Me</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dialogs; 